import React from 'react';
import CTAButton from './CTAButton';
export function FinalCTA() {
  return <section className="py-8 px-4 bg-gradient-to-b from-black to-gray-900 text-white" data-id="element-92">
      <div className="max-w-4xl mx-auto text-center" data-id="element-93">
        <div className="bg-white p-5 rounded-lg shadow-lg mb-4 text-left" data-id="element-94">
          <h3 className="text-2xl md:text-4xl font-black text-gray-800 mb-3" data-id="element-95">
            👨‍👩‍👧 ¿Para quién es?
          </h3>
          <ul className="space-y-2 mb-4" data-id="element-96">
            <li className="flex items-start" data-id="element-97">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-98">✔</span>
              <span className="text-xl text-gray-800" data-id="element-99">
                Padres con hijos de 5 a 15 años
              </span>
            </li>
            <li className="flex items-start" data-id="element-100">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-101">✔</span>
              <span className="text-xl text-gray-800" data-id="element-102">
                Personas que quieren educar mejor
              </span>
            </li>
            <li className="flex items-start" data-id="element-103">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-104">✔</span>
              <span className="text-xl text-gray-800" data-id="element-105">
                Familias que buscan un sistema simple
              </span>
            </li>
          </ul>

          <h3 className="text-2xl md:text-4xl font-black text-red-600 mb-3" data-id="element-106">
            ❌ ¿Para quién NO es?
          </h3>
          <ul className="space-y-2" data-id="element-107">
            <li className="flex items-start" data-id="element-108">
              <span className="text-red-600 font-bold mr-3" data-id="element-109">❌</span>
              <span className="text-lg text-gray-800" data-id="element-110">
                Personas que no aplican
              </span>
            </li>
            <li className="flex items-start" data-id="element-111">
              <span className="text-red-600 font-bold mr-3" data-id="element-112">❌</span>
              <span className="text-lg text-gray-800" data-id="element-113">
                Quienes buscan resultados sin hacer nada
              </span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 p-5 rounded-lg mb-6" data-id="element-114">
          <h3 className="text-2xl md:text-4xl font-black text-black mb-3" data-id="element-115">
            💬 ÚLTIMO MENSAJE
          </h3>
          <p className="text-xl text-black mb-2" data-id="element-116">
            No estás comprando un ebook.
          </p>
          <p className="text-xl text-black mb-2" data-id="element-117">
            Estás cambiando el futuro de tu hijo.
          </p>
          <p className="text-2xl font-bold text-black" data-id="element-118">Y eso…</p>
          <p className="text-2xl font-bold text-black" data-id="element-119">no tiene precio.</p>
        </div>

        <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-120">
          👉 ACCEDE AHORA Y EMPIEZA HOY
        </h2>

        <CTAButton text="🔘 QUIERO ACCEDER AHORA" data-id="element-121" />

        <div className="mt-6 text-sm text-gray-400" data-id="element-122">
          <p data-id="element-123">
            ✅ Acceso inmediato • ✅ Garantía de 7 días • ✅ Pago 100% seguro
          </p>
        </div>
      </div>
    </section>;
}
export default FinalCTA;